import React,{useState} from 'react'

export default function Table(props) {
  // animation: name duration timing-function delay iteration-count direction fill-mode;
  const [duration,setduration]=useState(0.5);
  const [delay,setdelay]=useState(0);
  const [iteration,setiteration]=useState(1);
  const [direction,setdirection]=useState('normal');
  const [fillmode,setfillmode]=useState('none');
  const [flg2,setflg2]=useState(true)
  function handelsubmit(e){
    e.preventDefault();
    props.tableData([duration,delay,iteration,direction,fillmode]);
  }
  
  if(flg2){
    props.tableData([0.5,0,1,'normal','both']);
    setflg2(false);
  }
  return (
      <div className='table'>
      <form onSubmit={handelsubmit} >
                <label htmlFor='durid' className='telem-heads'>Duration</label>
                <input type="number" className="telems" id='durid' placeholder="in seconds(0.5s)" onChange={(evt)=>{setduration(evt.target.value)}}/>
                <label htmlFor='delid' className='telem-heads'>Delay</label>
                <input id='delid' type="number" className="telems" placeholder="in seconds(0s)" onChange={(evt)=>{setdelay(evt.target.value)}}/>
                <label htmlFor='itid' className='telem-heads'>Itertion</label>
                <input id='itid' type="number" className="telems" placeholder='count(1)' onChange={(evt)=>{setiteration(evt.target.value)}}/>
                <label htmlFor='dir' className='telem-heads'>Direction</label>
                <select className="telems" id='dir' onChange={(evt)=>setdirection(evt.target.value)} >
                    <option value="normal" >normal</option>
                    <option value="reverse" >reverse</option>
                    <option value="alternate" >alternate</option>
                    <option value="alternate-reverse" >alternate-reverse</option>
                </select>
                <label htmlFor='fmode' className='telem-heads' id='fmodehead'>Fill-mode</label>
                <select className="telems" id='fmode' onChange={(evt)=>setfillmode(evt.target.value)}>
                    <option value="both">both</option>
                    <option value="foreward">foreward</option>
                    <option value="reverse">reverse</option>
                    <option value="none">none</option>
                </select>
                <button className='lastbtns' id='submit' type='submit'>Apply</button>
                <button className='lastbtns' id='reset' type='reset' onClick={()=>props.tableData([0.5,0,1,'normal','both'])} >Reset</button>
            </form>
    </div>
  )
}
